import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';
import InputsAboutPerson from './components/AboutPerson';
import PopUpWrapper from './components/PopUpWrapper';
import CustomBtn from '../../generic/CustomBtn';
import { requestApi } from '../../utils/api-request';
import { appStore } from '../../state/app';

const EditFieldAgentPopUp = ({ showPopUp, setShowPopUp, fieldAgensInfo }) => {
  const { handleSubmit, register } = useForm();
  const { update } = useContext(appStore);
  const translate = useIntl();

  const editFieldAgent = async (data) => {
    await requestApi('PUT', '/api/dashboard/field-agent', { ...data, field_agent_id: fieldAgensInfo.field_agent_id });
    const requestFieldAgentsList = await requestApi('GET', '/api/dashboard/field-agent/list');
    update('app.allFa', requestFieldAgentsList);
    setShowPopUp(!showPopUp);
  };

  return (
    <PopUpWrapper showPopUp={showPopUp} setShowPopUp={setShowPopUp} widthParam="width-654">
      <form onSubmit={handleSubmit(editFieldAgent)}>
        <h3 className="assign__caption">
          {translate.formatMessage({ id: 'popUp.fieldAgents.edit' })}
        </h3>
        <InputsAboutPerson
          register={register}
          fieldAgensInfo={fieldAgensInfo}
        />
        <CustomBtn
          label={translate.formatMessage({ id: 'button-save' })}
          customClass="assign__btn-accept"
          type="submit"
          handleClick={() => {}}
        />
      </form>
    </PopUpWrapper>
  );
};
export default EditFieldAgentPopUp;
